var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.6 490.6",
    style: {
      enableBackground: "new 0 0 490.6 490.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M393,0H97.6c-14,0-25.3,11.3-25.3,25.3v332.6c0,11.5,5.6,22.2,15,28.8l140.8,98.5c10.3,7.2,24.1,7.2,34.4,0l140.8-98.5 c9.4-6.6,15-17.3,15-28.8V25.3C418.3,11.3,407,0,393,0z M351.5,189.9l-48.1,40.9l15,61.5c2.8,11.6-9.7,20.8-19.8,14.5l-53.3-33.5 l-53.4,33.4c-10.1,6.3-22.6-2.9-19.8-14.5l15-61.5L139,189.8c-9-7.7-4.3-22.6,7.6-23.4l62.7-4.6l23.7-58.7c4.5-11,20-11,24.5,0 l23.7,58.7l62.7,4.6C355.8,167.3,360.6,182.2,351.5,189.9z",
    fill: "#f75d83"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.c1ebd789ffc0b1166844a89d7e6d89b2.svg";
export { ForwardRef as ReactComponent };